<template>
  <div class="page">
    <div class="page__bd">
      <div class="weui-cells__title">选择公司</div>

      <div class="weui-cells weui-cells_radio">
        <label
          class="weui-cell weui-cell_active weui-check__label"
          v-for="item in account.companies"
          :key="item.id"
        >
          <div class="weui-cell__bd">
            <p>{{ item.name }}</p>
          </div>
          <div class="weui-cell__ft">
            <input
              type="radio"
              class="weui-check"
              name="value"
              :value="item.id"
              v-model="account.companyId"
            />
            <span class="weui-icon-checked"></span>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from "@/util/auth.js";
import Session from '@/util/session';

export default {
  data() {
    return {
      account: {
          companyId: null
      },
    };
  },
  created() {
    this.loadData();
  },
  watch: {
    'account.companyId': function(newVal, oldVal) {
      if (oldVal && newVal) {
        this.switchCompany(newVal);
      }
    },
  },
  methods: {
    loadData() {
      const me = this;
      Auth.get()
        .then(function (data) {
          let account = data.account;
          me.account = account;
        })
        .catch(function (res) {
          me.$router.push({
            name: "Error",
            params: res
          });
        });
    },
    switchCompany(companyId) {
      const me = this;
      me.$loading({
        url: "/api/auth/switch/company",
        method: "POST",
        headers: {
          Authorization: Session.getToken(),
        },
        params: {
          companyId,
        },
        withCredentials: true
      }).then(function (res) {
        if (res.success) {
          let token = res.data,
            account = Object.assign(me.account),
            company = account.companies.find(
              (item) => item.id == companyId
            ),
            appId = company.app;
          account.defaultCompany = company;
          Auth.set({
            token,
            appId,
            account,
          });
          me.$router.push("/" + appId.replace("-app", ""));
        } else {
          me.$weui.topTips("切换失败：" + res.message, 3000);
        }
      });
    },
  },
};
</script>